import React from 'react';
import { StarIcon } from 'lucide-react';
interface StarRatingProps {
  rating?: number;
  label?: string;
}
export function StarRating({
  rating = 5,
  label
}: StarRatingProps) {
  return <div className="flex items-center gap-1" role="img" aria-label={label ?? `${rating} out of 5 stars`} data-id="element-351" data-mp="3kd2f3bg0mie6">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className={index < rating ? 'h-4 w-4 fill-gold text-gold' : 'h-4 w-4 text-navy/20'} aria-hidden="true" data-id="element-352" data-mp="3p5ltgamj1hk1" data-mpi={index} />)}
    </div>;
}